// extracted by mini-css-extract-plugin
export default {"container":"Xn-z","bubbleNav":"Yn-z","graphic":"Zn-z","contact":"_n-z"};